import loadingImg from "../../assets/img/preload.gif";

const FormularioEstados = ({ status, onRetry }) => {
  if (status === "cargando") {
    return (
      <div className="text-center my-5">
        <img src={loadingImg} alt="Cargando…" style={{ maxWidth: 150 }} />
        <p>Enviando tus datos…</p>
      </div>
    );
  }

  if (status === "ok") {
    return (
      <div className="mensaje-exito-container">
        <div className="icono-check">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="white" />
          </svg>
        </div>
        <p className="mensaje-exito-texto">
          <strong>¡Gracias!</strong> Recibimos tu solicitud de test drive. Te contactaremos a la brevedad.
        </p>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="text-center my-5">
        <p className="text-danger fw-bold fs-4 mb-0">Se ha producido un error</p>
        <p>Volvé a intentarlo más tarde</p>
        {onRetry && (
          <button type="button" className="btn-black mt-3" onClick={onRetry} style={{ color: "white" }}>
            Reintentar
          </button>
        )}
      </div>
    );
  }

  return null;
};

export default FormularioEstados;
